import { ref } from 'vue'

interface TransferRequest {
  chatId: string
  contactName: string
  contactPhone: string
  transfer_message?: string
  fromUserId: string
  fromUserName: string
  fromCampaignId: string
  fromCampaignName: string
  toUserId: string
  toUserName: string
  toCampaignId: string
  toCampaignName: string
}

const pendingTransfers = ref<TransferRequest[]>([])
const currentTransferRequest = ref<TransferRequest | null>(null)

export const useTransferRequests = () => {
  const syncCurrentTransferRequest = () => {
    currentTransferRequest.value = pendingTransfers.value[0] || null
  }

  const addTransferRequest = (request: TransferRequest) => {
    const exists = pendingTransfers.value.find((t) => t.chatId === request.chatId)
    if (exists) {
      return
    }

    pendingTransfers.value.push(request)
    syncCurrentTransferRequest()
  }

  const removeTransferRequest = (chatId: string) => {
    pendingTransfers.value = pendingTransfers.value.filter((transfer) => transfer.chatId !== chatId)
    syncCurrentTransferRequest()
  }

  const acceptTransfer = (chatId: string) => {
    removeTransferRequest(chatId)
  }

  const rejectTransfer = (chatId: string) => {
    removeTransferRequest(chatId)
  }

  const clearAll = () => {
    pendingTransfers.value = []
    currentTransferRequest.value = null
  }

  return {
    pendingTransfers,
    currentTransferRequest,
    addTransferRequest,
    removeTransferRequest,
    acceptTransfer,
    rejectTransfer,
    clearAll,
  }
}

